/**
 * Intrinsic size of the source wordmark (`src/assets/logo.png`, 1024×131).
 * Display slots scale it down via CSS (`max-h-*` / `object-contain`) — do not generate smaller exports.
 */
export const LOGO_HEADER_INTRINSIC = { width: 1024, height: 131 } as const;

/** Always combine with max-height and/or max-width constraints as needed. */
export const logoHeaderImgBaseClass = "block h-auto w-auto object-contain";
